import { useState } from 'react';
import { useSearchFields } from '../SearchFieldProvider';
import { useNavigate } from 'react-router-dom';

export default function SearchBar() {
    const navigate = useNavigate();
    const { setKeyword, setLocation, setStartDate, setEndDate } = useSearchFields();
    const [keywordInput, setKeywordInput] = useState("");
    const [locationInput, setLocationInput] = useState("");
    const [startDateInput, setStartDateInput] = useState("");
    const [endDateInput, setEndDateInput] = useState("");
    const [inputType, setInputType] = useState('text');

    const handleFocus = () => {
        setInputType('date');
    };

    const onSubmit = () => {
        setKeyword(keywordInput);
        setLocation(locationInput);
        setStartDate(startDateInput);
        setEndDate(endDateInput);
        navigate('/searchResults');
    };

    document.addEventListener("keydown", e => {
        if (e.key === "Enter") {
            onSubmit();
        }
    });

    return (
            <div className="row justify-content-around search-bar mx-auto search-outline w-100 gx-2"> 
                <div className="col-10 col-lg-auto me-auto">
                    <div className="input-group input-group-lg">
                        <input type="text" className="form-control" placeholder="Keyword" aria-label="Keyword" 
                            style={{ borderTopLeftRadius: 500, borderBottomLeftRadius: 500}} value={keywordInput}
                            onChange={event => setKeywordInput(event.target.value)}/>
                        <input type="text" className="form-control d-none d-md-block" placeholder="Location" aria-label="Location"
                            onChange={event => setLocationInput(event.target.value)} value={locationInput}/>
                        <input id="startDate" className="form-control" type={inputType} style={{ fontSize: 16, color: "gray"}} placeholder="Start"
                            onChange={event => setStartDateInput(event.target.value)} value={startDateInput} onFocus={handleFocus}/>
                        <input id="endDate" className="form-control" type={inputType} 
                            onChange={event => setEndDateInput(event.target.value)} value={endDateInput} onFocus={handleFocus} placeholder="End"
                            style={{ borderTopRightRadius: 500, borderBottomRightRadius: 500, fontSize: 16, color: "gray"}}/>
                    </div>
                </div>
                <div className="col-2 col-lg-auto">
                    <button className="btn btn-lg btn-dark" type="submit" onClick={onSubmit}
                    style={{ borderRadius: 500 }}>
                            <i className="fa fa-search"></i>
                    </button>
                </div>
                
            </div>
    );
}
